import { Component } from "react";
import { NSARouterMakerResult } from "namirasoft-account-react";
import { CredentialEntities } from "../CredentialEntities";
import { CredentialLayout } from '../CredentialLayout';
import { CredentialProps } from "../CredentialProps";

export interface GitHubListPageProps extends NSARouterMakerResult, CredentialProps { }

class GitHubListPage extends Component<GitHubListPageProps>
{
    override render()
    {
        return (
            <CredentialLayout
                {...this.props}
                action={{
                    description: "This section lists all the GitHub credentials saved in your workspace, showing each one's name and identifiers. You can open, copy, edit, or delete any entry, review its change history, or create a new one.",
                }}
                pages={{
                    entity: CredentialEntities.git_hub(this.props),
                    list: {
                        ui: {}
                    }
                }}
            >
                <></>
            </CredentialLayout >
        );
    }
}

export default GitHubListPage;